export default {
  services: "Services",
  howToOperate: "How to Operate",
  regulations: "Regulations",
  commissary: "Commissary",
  about: "About",
  contact: "Contact",
  bookSession: "Book a Session",
};